export interface HsvColor { hue: number; saturation: number; brightness: number }
export const PERSONAL_PALETTE_LIMIT = 12;
export function normalizeHex(value: string): string | null {
  return /^#[0-9a-f]{6}$/i.test(value) ? value.toLowerCase() : null;
}
/** Only an accepted active paint color enters the bounded quick strip. Existing choices keep their order. */
export function rememberQuickColor(colors:string[],selected:string):string[] {
  const color=normalizeHex(selected);
  return !color||colors.includes(color)?colors:[color,...colors].slice(0,6);
}
export function hexToHsv(hex: string, fallbackHue = 0): HsvColor {
  const normalized = normalizeHex(hex);
  if (!normalized) throw new Error('Use a six-digit hex color.');
  const [red, green, blue] = [1, 3, 5].map(start => parseInt(normalized.slice(start, start + 2), 16) / 255);
  const max = Math.max(red, green, blue), min = Math.min(red, green, blue), delta = max - min;
  let hue = fallbackHue;
  if (delta) {
    hue = max === red ? ((green - blue) / delta) % 6 : max === green ? (blue - red) / delta + 2 : (red - green) / delta + 4;
    hue = (hue * 60 + 360) % 360;
  }
  return { hue, saturation: max ? delta / max * 100 : 0, brightness: max * 100 };
}
/** The shared palette opens at the exact current paint, including neutral colors. */
export function initialCustomColor(hex: string, fallbackHue = 20): HsvColor {
  return hexToHsv(hex, fallbackHue);
}
export function hsvToHex({ hue, saturation, brightness }: HsvColor): string {
  const h = ((hue % 360) + 360) % 360 / 60, s = Math.max(0, Math.min(100, saturation)) / 100, v = Math.max(0, Math.min(100, brightness)) / 100;
  const chroma = v * s, x = chroma * (1 - Math.abs(h % 2 - 1)), m = v - chroma;
  const rgb = h < 1 ? [chroma, x, 0] : h < 2 ? [x, chroma, 0] : h < 3 ? [0, chroma, x] : h < 4 ? [0, x, chroma] : h < 5 ? [x, 0, chroma] : [chroma, 0, x];
  return '#' + rgb.map(value => Math.round((value + m) * 255).toString(16).padStart(2, '0')).join('');
}
